import {Observable, BehaviorSubject} from 'rxjs';
import {pluck, distinctUntilChanged} from 'rxjs/operators';
import {User} from './core/models/User';
import {QueryConfig} from './core/models/QueryConfig';

export interface State {
    legalEntities: any;
    user: User;
    shockMtmValue: string;
    urlModelToggle: any;
    modellingConfig: QueryConfig;
    apiToken: string;
    tempApiToken: string;
    pageReload: string;
}

const state: State = {
    legalEntities: {},
    user: undefined,
    shockMtmValue: '1',
    urlModelToggle: {},
    modellingConfig: <QueryConfig>{
        rolloverToCash: false,
        setForGroup: false,
        entityTailConfigs: undefined,
        groupTailConfig: [
            {from: 0, to: 120, tail: 0.02}
        ],
        modelId: null
    },
    apiToken: undefined,
    tempApiToken: undefined,
    pageReload: ''
};

export class Store {

    private subject = new BehaviorSubject<State>(state);
    private store = this.subject.asObservable().pipe(distinctUntilChanged());

    get value() {
        return this.subject.value;
    }

    select<T>(name): Observable<T> {
        return this.store.pipe(pluck(name));
    }

    set(name: string, stateObj: any) {
        this.subject.next({...this.value, [name]: stateObj});
    }
}
